import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/ThirdPartyExternalExposure.scss';
import { Accordion, Button, Card, Modal } from 'react-bootstrap';
import { thirdpartyExternalExposureQuestionsService, deleteThirdpartyQuestionsService, getTprmAssessmentsService, createTprmAssessmentService, getTprmAssessmentCategoriesService, third_party_monitored_vendors, getThirdpartyQuestionsTemplateService, bulkUploadThirdpartyQuestionsService } from '../../services';
import CreateTPRMQuestionModal from './CreateTPRMQuestionModal';
import BulkUploadQuestionsModal from './BulkUploadQuestionsModal';
import CommonButton from '../../Components/CommonButton';
import ButtonLoader from '../../Components/ButtonLoader';
import { formatText } from '../../helper';


function OrganizationQuestions() {
  const navigate = useNavigate();
  const [allQuestions, setAllQuestions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [category, setCategory] = useState('');
  const [responseType, setResponseType] = useState('');
  const [downloadingTemplate, setDownloadingTemplate] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState(null);
  const [assessments, setAssessments] = useState([]);
  const [loadingAssessments, setLoadingAssessments] = useState(false);
  const [creatingAssessment, setCreatingAssessment] = useState(false);
  const [assessmentForm, setAssessmentForm] = useState({
    relation_id: '',
    expiry_days: 15
  });
  const [categories, setCategories] = useState({
    default_categories: [],
    org_categories: []
  });
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [vendorRelations, setVendorRelations] = useState([]);
  const [loadingVendorRelations, setLoadingVendorRelations] = useState(false);
  const [resMsg, setResMsg] = useState('');
  const [errResMsg, setErrResMsg] = useState('');
  const [deleteErrMsg, setDeleteErrMsg] = useState('');
  const [downloadError, setDownloadError] = useState('');





  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const response = await thirdpartyExternalExposureQuestionsService('');
      console.log(response.statusCode.response_data.data.admin_questions, 'responseresponseresponse')
      // Handle different response structures
      let data = [];
      // if (response?.statusCode?.response_data?.data?.admin_questions || response?.statusCode?.response_data?.data?.organization_questions) {
      //   data = [...response?.statusCode?.response_data?.data?.admin_questions, response?.statusCode?.response_data?.data?.organization_questions];
      // } 

      if (
        response?.statusCode?.response_data?.data?.admin_questions ||
        response?.statusCode?.response_data?.data?.organization_questions
      ) {
        const adminQuestions =
          response?.statusCode?.response_data?.data?.admin_questions?.map(item => ({
            ...item,
            created_by_que: "admin",
          })) || [];

        const organizationQuestions =
          response?.statusCode?.response_data?.data?.organization_questions || [];

        data = [...adminQuestions, ...organizationQuestions];
      }

      setAllQuestions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching TPRM questions:", error);
      setAllQuestions([]);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchQuestions();
  }, []);



  const handleCreateSuccess = () => {
    fetchQuestions();
    setShowCreateModal(false);
  };

  const handleEditClick = (question) => {
    setEditingQuestion(question);
    setShowCreateModal(true);
  };

  const handleDeleteClick = (question) => {
    setQuestionToDelete(question);
    setShowDeleteModal(true);
  };

  const handleShareQuestionnaire = async (questionnaireName, questions) => {
    setSelectedQuestionnaire({ name: questionnaireName, questions: questions });
    setShowShareModal(true);
    // Reset form
    setAssessmentForm({
      relation_id: '',
      expiry_days: 15
    });

    // Fetch vendor relations
    setLoadingVendorRelations(true);
    try {
      const response = await third_party_monitored_vendors({});

      const relations = response?.statusCode?.response_data?.data || [];

      setVendorRelations(Array.isArray(relations) ? relations : []);
    } catch (error) {
      console.error('Error fetching vendor relations:', error);
      setVendorRelations([]);
    } finally {
      setLoadingVendorRelations(false);
    }
  };

  const handleCreateAssessment = async () => {
    // Clear previous messages
    setResMsg('');
    setErrResMsg('');

    // Validation
    // Validation
    if (!assessmentForm.relation_id || !selectedQuestionnaire?.name) {
      setErrResMsg('Please fill in all required fields (Vendor is required)');
      return;
    }

    setCreatingAssessment(true);
    try {
      const questionnaireName = selectedQuestionnaire.name;

      let params = {
        relation_id: parseInt(assessmentForm.relation_id),
        questionnaire_name: questionnaireName,
        questionnaire_name: questionnaireName,
        expiry_days: assessmentForm.expiry_days,
        send_immediately: true
      };
      const response = await createTprmAssessmentService(params);
      console.log('Create Assessment Response:', response);

      const successMessage =
        response?.statusCode?.response_data?.message ||
        response?.statusCode?.message ||
        response?.data?.message;

      const errorMessage =
        response?.errors?.message ||
        response?.error?.message ||
        response?.statusCode?.error?.message;

      if (successMessage && !errorMessage) {
        setResMsg(successMessage || 'Vendor assessment created successfully!');
        // Reset form and close modal after delay
        setTimeout(() => {
          setShowShareModal(false);
          setSelectedQuestionnaire(null);
          setResMsg('');
          // Reset form
          setAssessmentForm({
            relation_id: '',
            expiry_days: 15
          });
        }, 1500);
      } else if (errorMessage) {
        setErrResMsg(errorMessage || 'Failed to create assessment. Please try again.');
      }
    } catch (error) {
      console.error('Error creating assessment:', error);
      setErrResMsg('Failed to create assessment. Please try again.');
    } finally {
      setCreatingAssessment(false);
    }
  };

  const handleViewQuestionnaire = async (questionnaireName, questions) => {
    setSelectedQuestionnaire({ name: questionnaireName, questions: questions });
    setShowViewModal(true);
    // Fetch assessments
    setLoadingAssessments(true);
    try {
      let query = `?questionnaire_name=${questionnaireName}`;
      const response = await getTprmAssessmentsService(query);
      console.log('Assessments Response:', response);

      const assessmentData = response?.statusCode?.response_data?.data?.assessments ||
        response?.data?.assessments || [];
      setAssessments(Array.isArray(assessmentData) ? assessmentData : []);
    } catch (error) {
      console.error('Error fetching assessments:', error);
      setAssessments([]);
    } finally {
      setLoadingAssessments(false);
    }
  };




  useEffect(() => {
    let filtered = [...allQuestions];

    // Filter by category
    if (category) {
      filtered = filtered.filter((q) => {
        const questionCategory = q.category_display || q.category || "";
        return questionCategory === category;
      });
    }

    // Filter by response type
    if (responseType) {
      filtered = filtered.filter((q) => {
        const questionResponseType =
          q.response_type_display || q.response_type || "";

        const responseTypeMap = {
          "Yes / No": ["yes_no", "Yes / No", "Yes/No"],
          "Multi-select": ["multi_select", "Multi-select", "Multi Select"],
          "Text": ["text", "Text"],
          "File Upload": ["file_upload", "File Upload"],
          "Rating (1-5)": ["rating", "Rating (1-5)", "Rating"],
        };

        const mappedTypes = responseTypeMap[responseType] || [responseType];

        return mappedTypes.some(
          (type) =>
            questionResponseType.toLowerCase() === type.toLowerCase()
        );
      });
    }

    // ✅ Group by questionnaire_name -> category + created_by_que -> sub_category
    const groupedData = filtered.reduce((acc, question) => {
      const questionnaireName = question.questionnaire_name || "Default";

      const categoryName =
        question.category_display || question.category || "Uncategorized";

      const createdBy = question.created_by_que || "";
      const categoryKey = createdBy ? `${categoryName} (${createdBy})` : categoryName;

      // Use actual sub_category or null marker for ungrouped
      const subCategoryName = question.sub_category || "__no_sub_category__";

      if (!acc[questionnaireName]) {
        acc[questionnaireName] = {};
      }

      if (!acc[questionnaireName][categoryKey]) {
        acc[questionnaireName][categoryKey] = {};
      }

      if (!acc[questionnaireName][categoryKey][subCategoryName]) {
        acc[questionnaireName][categoryKey][subCategoryName] = [];
      }

      acc[questionnaireName][categoryKey][subCategoryName].push(question);
      return acc;
    }, {});

    setQuestions(groupedData);
  }, [allQuestions, category, responseType]);





  const handleDeleteConfirm = async () => {
    if (!questionToDelete) return;

    setDeleting(true);
    setDeleteErrMsg('');
    try {
      const response = await deleteThirdpartyQuestionsService(`${questionToDelete.id}/`);

      const successMessage =
        response?.statusCode?.response_data?.message ||
        response?.statusCode?.message;
      const errorMessage =
        response?.errors?.message ||
        response?.error?.message ||
        response?.statusCode?.error?.message;

      if (successMessage && !errorMessage) {
        // Refresh questions list
        fetchQuestions();
        setShowDeleteModal(false);
        setQuestionToDelete(null);
      } else if (errorMessage) {
        console.error("Error deleting question:", errorMessage);
        setDeleteErrMsg(errorMessage || "Failed to delete question. Please try again.");
      } else {
        // If no explicit error but also no success message, still refresh
        fetchQuestions();
        setShowDeleteModal(false);
        setQuestionToDelete(null);
      }
    } catch (error) {
      console.error("Error deleting question:", error);
      setDeleteErrMsg("Failed to delete question. Please try again.");
    } finally {
      setDeleting(false);
    }
  };

  const handleDownloadTemplate = async () => {
    setDownloadingTemplate(true);
    setDownloadError('');
    try {
      const response = await getThirdpartyQuestionsTemplateService();
      const blob = response?.statusCode;

      if (!blob) {
        throw new Error('Empty response from server');
      }

      // Check if response is an error (JSON) or actual file
      let fileBlob;
      const fileName = 'organization_questions_template.xlsx';

      if (blob.type === 'application/json') {
        // Error response
        const errorText = await blob.text();
        const errorData = JSON.parse(errorText);
        console.error('Error details:', errorData?.error?.message);
        setDownloadError(`Download failed: ${errorData?.error?.message || 'No data available'}`);
        return;
      } else {
        // Valid file
        fileBlob = new Blob([blob], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
      }

      // Download file
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();

      // Cleanup after delay to ensure download starts
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Error downloading template:", error);
      setDownloadError("Failed to download template. Please try again.");
    } finally {
      setDownloadingTemplate(false);
    }
  };

  const handleBulkUploadSuccess = () => {
    fetchQuestions();
    setShowBulkUploadModal(false);
  };


  return (
    <div className='organization_questions_page'>
      <div className='d-flex align-items-center mb-4'>
        <img
          src='https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/external-attack-surface-scan.svg'
          alt='organization-questions'
          height={32}
          width={32}
        />
        <h3 className='color_white mb-0 font_20 font-600 ms-3'>Organization Questions</h3>

        <div className='ms-auto d-flex gap-2 align-items-center'>
          <Button
            variant="outline-light"
            onClick={handleDownloadTemplate}
            disabled={downloadingTemplate}
            className="d-flex align-items-center gap-1"
          >
            {downloadingTemplate ? <ButtonLoader /> : <>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
              </svg>
              Template
            </>}
          </Button>
          <Button
            variant="outline-light"
            onClick={() => setShowBulkUploadModal(true)}
            className="d-flex align-items-center gap-1"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V10.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
            </svg>
            Add Questionnaire
          </Button>
          <CommonButton
            onClick={() => setShowCreateModal(true)}
            text="+ Create Question"
            className="blue_btn"
          />
        </div>
      </div>

      {downloadError && (
        <div className="alert alert-danger alert-dismissible fade show mb-4" role="alert">
          <strong>Error!</strong> {downloadError}
          <button type="button" className="btn-close" onClick={() => setDownloadError('')}></button>
        </div>
      )}

      <div className='organization_questions_content'>
        <div className="row">
          <div className="col-md-12 mb-2">
            <Accordion className="accordion_tprm" defaultActiveKey="0" flush>
              {Object.entries(questions).map(([questionnaireName, categories], qIndex) => (
                <Accordion.Item
                  eventKey={qIndex.toString()}
                  key={questionnaireName}
                  className="mb-3 border rounded overflow-hidden"
                >
                  <Accordion.Header>
                    <div className="d-flex align-items-center gap-2 w-100">
                      <span className="fw-bold">{formatText(questionnaireName)}</span>
                      <span className="badge bg-primary">
                        {Object.values(categories).reduce((acc, catSubs) => acc + Object.values(catSubs).reduce((a, qs) => a + qs.length, 0), 0)} Questions
                      </span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body className="p-0 bg-transparent">
                    <Accordion className="accordion_tprm inner-accordion" defaultActiveKey="0" flush>
                      {Object.entries(categories).map(([categoryName, subCategories], categoryIndex) => (
                        <Accordion.Item
                          eventKey={`${qIndex}-${categoryIndex}`}
                          key={categoryName}
                          className="border-bottom-0"
                        >
                          <Accordion.Header>
                            <div className="d-flex align-items-center gap-2 w-100 ps-3">
                              <span className="fw-semibold">{formatText(categoryName)}</span>
                              <span className="badge bg-primary">
                                {Object.values(subCategories).reduce((a, qs) => a + qs.length, 0)} {Object.values(subCategories).reduce((a, qs) => a + qs.length, 0) === 1 ? 'Question' : 'Questions'}
                              </span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="p-0 bg-transparent">
                            {/* Render ungrouped questions (no sub_category) directly */}
                            {subCategories['__no_sub_category__'] && subCategories['__no_sub_category__'].map((question, questionIndex) => (
                              <Card
                                key={question.id || questionIndex}
                                className="questionnaire_card p-3 mb-2 shadow-sm"
                              >
                                <h5 className="color_white fw-semibold mb-1 d-flex justify-content-between align-items-start">
                                  <span>{questionIndex + 1}. {question.question_text || "N/A"}</span>
                                  <div className="d-flex gap-2 align-items-center">
                                    {question.created_by_que !== 'admin' && (
                                      <>
                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() => handleEditClick(question)}
                                          title="Edit Question"
                                        >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                          </svg>
                                        </button>
                                        <button
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() => handleDeleteClick(question)}
                                          title="Delete Question"
                                        >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                            <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                          </svg>
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </h5>

                                {question.expected_evidence && (
                                  <p className="mb-2" style={{ color: 'rgb(13, 202, 240)' }}>
                                    <span className="font_600">Expected Evidence: </span>
                                    {question.expected_evidence}
                                  </p>
                                )}

                                <div className="d-flex gap-4 mb-3">
                                  <span className="badge bg-primary px-3 py-2">
                                    Response Type: {question.response_type_display || question.response_type || "N/A"}
                                  </span>
                                </div>

                                {question.multi_select_options &&
                                  Array.isArray(question.multi_select_options) &&
                                  question.multi_select_options.length > 0 && (
                                    <div className="mb-2">
                                      <span className="font_600 d-block mb-1 text-info">
                                        Multi-select Options:
                                      </span>
                                      <ol className="ps-3 mb-0">
                                        {question.multi_select_options.map((option, optIndex) => (
                                          <li key={optIndex}>{option}</li>
                                        ))}
                                      </ol>
                                    </div>
                                  )}

                              </Card>
                            ))}

                            {/* Render sub_category grouped questions in accordion */}
                            {Object.entries(subCategories).filter(([key]) => key !== '__no_sub_category__').length > 0 && (
                              <Accordion className="accordion_tprm inner-accordion" defaultActiveKey="0" flush>
                                {Object.entries(subCategories).filter(([key]) => key !== '__no_sub_category__').map(([subCategoryName, subCategoryQuestions], subCatIndex) => (
                                  <Accordion.Item
                                    eventKey={`${qIndex}-${categoryIndex}-${subCatIndex}`}
                                    key={subCategoryName}
                                    className="border-bottom-0"
                                  >
                                    <Accordion.Header>
                                      <div className="d-flex align-items-center gap-2 w-100 ps-4">
                                        <span className="fw-semibold" style={{ fontSize: '14px' }}>{formatText(subCategoryName)}</span>
                                        <span className="badge bg-info">
                                          {subCategoryQuestions.length} {subCategoryQuestions.length === 1 ? 'Question' : 'Questions'}
                                        </span>
                                      </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      {subCategoryQuestions.map((question, questionIndex) => (
                                        <Card
                                          key={question.id || questionIndex}
                                          className="questionnaire_card p-3 mb-2 shadow-sm"
                                        >
                                          <h5 className="color_white fw-semibold mb-1 d-flex justify-content-between align-items-start">
                                            <span>{questionIndex + 1}. {question.question_text || "N/A"}</span>
                                            <div className="d-flex gap-2 align-items-center">
                                              {question.created_by_que !== 'admin' && (
                                                <>
                                                  <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => handleEditClick(question)}
                                                    title="Edit Question"
                                                  >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                      <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                                    </svg>
                                                  </button>
                                                  <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleDeleteClick(question)}
                                                    title="Delete Question"
                                                  >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                      <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                    </svg>
                                                  </button>
                                                </>
                                              )}
                                            </div>
                                          </h5>

                                          {question.expected_evidence && (
                                            <p className="mb-2" style={{ color: 'rgb(13, 202, 240)' }}>
                                              <span className="font_600">Expected Evidence: </span>
                                              {question.expected_evidence}
                                            </p>
                                          )}

                                          <div className="d-flex gap-4 mb-3">
                                            <span className="badge bg-primary px-3 py-2">
                                              Response Type: {question.response_type_display || question.response_type || "N/A"}
                                            </span>
                                          </div>

                                          {question.multi_select_options &&
                                            Array.isArray(question.multi_select_options) &&
                                            question.multi_select_options.length > 0 && (
                                              <div className="mb-2">
                                                <span className="font_600 d-block mb-1 text-info">
                                                  Multi-select Options:
                                                </span>
                                                <ol className="ps-3 mb-0">
                                                  {question.multi_select_options.map((option, optIndex) => (
                                                    <li key={optIndex}>{option}</li>
                                                  ))}
                                                </ol>
                                              </div>
                                            )}

                                        </Card>
                                      ))}
                                    </Accordion.Body>
                                  </Accordion.Item>
                                ))}
                              </Accordion>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>


      <CreateTPRMQuestionModal
        show={showCreateModal}
        onHide={() => {
          setShowCreateModal(false);
          setEditingQuestion(null);
        }}
        onSuccess={handleCreateSuccess}
        editingQuestion={editingQuestion}
      />

      <BulkUploadQuestionsModal
        show={showBulkUploadModal}
        onHide={() => setShowBulkUploadModal(false)}
        onSuccess={handleBulkUploadSuccess}
      />


      {/* Delete Confirmation Modal */}
      <Modal
        className='cstm_modal'
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setQuestionToDelete(null);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-3 text-white'>
          <p className="mb-0">
            Are you sure you want to delete this question? This action cannot be undone.
          </p>
          {questionToDelete && (
            <div className="mt-3">
              <strong>Question:</strong> {questionToDelete.question_text || "N/A"}
            </div>
          )}

          {/* Error Message */}
          {deleteErrMsg && (
            <div className="alert alert-danger alert-dismissible fade show mt-3" role="alert">
              <strong>Error!</strong> {deleteErrMsg}
              <button type="button" className="btn-close" onClick={() => setDeleteErrMsg('')}></button>
            </div>
          )}

          <div className="d-flex gap-2 mt-3 justify-content-end">
            <Button
              variant="secondary"
              onClick={() => {
                setShowDeleteModal(false);
                setQuestionToDelete(null);
              }}
              disabled={deleting}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteConfirm}
              disabled={deleting}
            >
              {deleting ? <ButtonLoader /> : "Delete"}
            </Button>
          </div>
        </Modal.Body>

      </Modal>

      {/* Share Modal - Create Vendor Assessment */}
      <Modal
        className='cstm_modal'
        show={showShareModal}
        onHide={() => {
          setShowShareModal(false);
          setSelectedQuestionnaire(null);
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Vendor Assessment</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-3'>
          <div className="mb-3">
            <p className="text-white mb-3">
              Create and send a vendor assessment with {selectedQuestionnaire?.questions?.length || 0} questions.
            </p>

            {/* Success Message */}
            {resMsg && (
              <div className="alert alert-success alert-dismissible fade show" role="alert">
                <strong>Success!</strong> {resMsg}
                <button type="button" className="btn-close" onClick={() => setResMsg('')}></button>
              </div>
            )}

            {/* Error Message */}
            {errResMsg && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {errResMsg}
                <button type="button" className="btn-close" onClick={() => setErrResMsg('')}></button>
              </div>
            )}

            <div className="form-group mb-3">
              <label className="form-label fw-semibold text-white">
                Vendor <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                value={assessmentForm.relation_id}
                onChange={(e) => setAssessmentForm({
                  ...assessmentForm,
                  relation_id: e.target.value
                })}
                required
                disabled={loadingVendorRelations}
              >
                <option value="">
                  {loadingVendorRelations ? 'Loading vendors...' : 'Select Vendor'}
                </option>

                {vendorRelations.map((vendor) => (
                  <option key={vendor.id || vendor.relation_id} value={vendor.id || vendor.relation_id}>
                    {vendor.target_organization_name || vendor.vendor_name || vendor.name || `Vendor ${vendor.id || vendor.relation_id}`}
                  </option>
                ))}
              </select>
              <small className="text-white">
                Select the vendor for this assessment
                {loadingVendorRelations && <span className="ms-2 spinner-border spinner-border-sm" role="status"></span>}
              </small>
            </div>

            <div className="form-group mb-3">
              <label className="form-label fw-semibold text-white">
                Questionnaire
              </label>
              <div className="p-3 bg-light rounded">
                <strong>{formatText(selectedQuestionnaire?.name) || 'N/A'}</strong>
                <small className="text-white d-block mt-1">
                  This questionnaire will be used for the assessment
                </small>
              </div>
            </div>

            <div className="form-group mb-3">
              <label className="form-label fw-semibold text-white">Expiry Days</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter expiry days"
                value={assessmentForm.expiry_days}
                onChange={(e) => setAssessmentForm({
                  ...assessmentForm,
                  expiry_days: parseInt(e.target.value) || 15
                })}
                min="1"
              />
              <small className="text-white">Number of days until assessment expires (default: 15)</small>
            </div>

          </div>

          <div className='d-flex justify-content-end gap-2'>
            <Button
              variant="secondary"
              onClick={() => {
                setShowShareModal(false);
                setSelectedQuestionnaire(null);
              }}
              disabled={creatingAssessment}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleCreateAssessment}
            // disabled={creatingAssessment || !assessmentForm.relation_id || !assessmentForm.category}
            >
              {creatingAssessment ? <ButtonLoader /> : 'Create & Send Assessment'}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* View Modal - Assessments List */}
      <Modal
        className='cstm_modal'
        show={showViewModal}
        onHide={() => {
          setShowViewModal(false);
          setSelectedQuestionnaire(null);
          setAssessments([]);
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton className='pb-0'>
          <Modal.Title>View Assessments</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-3' style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {loadingAssessments ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2 text-white">Loading assessments...</p>
            </div>
          ) : (
            <div className="mb-3">
              <p className="mb-3 text-white">
                Total Assessments: <strong>{assessments.length}</strong>
              </p>

              {assessments.length === 0 ? (
                <div className="text-center py-5">
                  <p className="text-muted">No assessments found</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table cm_table_dark">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>Vendor Name</th>
                        <th>Email</th>
                        <th>Category</th>
                        <th>Status</th>
                        <th>Created</th>
                        <th>Expires</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assessments.map((assessment, index) => (
                        <tr key={assessment.id || index}>
                          {console.log(assessment, 'assessmentassessmentassessment')}
                          <td>{index + 1}</td>
                          <td className="fw-semibold">
                            {assessment.vendor_name || "N/A"}
                          </td>
                          <td>
                            {assessment.vendor_email || "N/A"}
                          </td>
                          <td>
                            <span className="badge bg-info">
                              {assessment.category || "N/A"}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`badge ${assessment.status === 'completed' ? 'bg-success' :
                                assessment.status === 'sent' ? 'bg-info' :
                                  assessment.status === 'in_progress' ? 'bg-warning text-dark' :
                                    assessment.status === 'submitted' ? 'bg-primary' :
                                      assessment.status === 'under_review' ? 'bg-secondary' :
                                        assessment.status === 'rejected' ? 'bg-danger' :
                                          assessment.status === 'expired' ? 'bg-dark' :
                                            'bg-secondary'
                                }`}
                            >
                              {assessment.status ? assessment.status.replace('_', ' ').toUpperCase() : 'N/A'}
                            </span>
                          </td>
                          <td className="text-nowrap">
                            {assessment.created_at ? new Date(assessment.created_at).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            }) : "N/A"}
                          </td>
                          <td className="text-nowrap">
                            {assessment.expires_at ? new Date(assessment.expires_at).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            }) : "N/A"}
                          </td>
                          <td>
                            <button
                              className='btn btn-primary btn-sm text-nowrap'
                              onClick={() => navigate(`/vendor/assessment/${assessment.id}/responses`)}
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </Modal.Body>

      </Modal>


    </div >
  );
}

export default OrganizationQuestions;

